import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdEdit,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdSettings,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Sellerprofile.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate } from "react-router";
import VideoRecorder from "../components/VideoRecorder";

export default function SellerProfile({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  templates,
  categories,
  companyData,
  reload,
  setReload,
  becomeSellerActive,
  setBecomeSellerActive,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;

  const [isLoading, setIsLoading] = useState(false);
  const [instaProfile, setInstaProfile] = useState("");
  const [followerInstagram, setFollowerInstagram] = useState("");
  const [storyPostPrice, setStoryPostPrice] = useState("");

  useEffect(() => {
    if (!isEmpty(companyData)) {
      setInstaProfile(companyData.instagramProfileURL);
      setStoryPostPrice(companyData.priceInstagramStory);
      setFollowerInstagram(companyData.followerInstagram);
    }
  }, [companyData]);

  const clickSaveButton = async () => {
    setIsLoading(true);

    const resa = await fetch(
      `${apiURL}/api/companies/index.php?id=` + companyData.id.toString(),
      {
        method: "POST",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          instagramProfileURL: instaProfile,
          priceInstagramStory: storyPostPrice,
          followerInstagram: followerInstagram,
        }),
      }
    );

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = (value) => {
    setIsLoading(false);
    setReload(!reload);
    navigate("/seller");
  };

  useEffect(async () => {
    if (!isEmpty(companyData) && becomeSellerActive) {
      const resa = await fetch(
        `${apiURL}/api/companies/index.php?id=` + companyData.id.toString(),
        {
          method: "POST",
          headers: {
            //   Authorization: `Bearer ${authToken?.JWT}`,
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: JSON.stringify({
            isACreator: 1,
          }),
        }
      );
    }
  }, [companyData, becomeSellerActive]);

  return (
    <div className="sellerprofile">
      {isMobile ? (
        <div className="sellerprofile_topnav">
          <div
            className="sellerprofile_topnav_left"
            onClick={() => navigate("/seller")}>
            <ArrowBack />{" "}
            <div
              className="sellerprofile_topnav_left_button"
              onClick={() => navigate("/seller")}>
              Dein Werbeaccount
            </div>
          </div>

          <div
            className="sellerprofile_topnav_right"
            onClick={() => navigate("/menu")}>
            <div className="sellerprofile_topnav_right_button">
              <SettingsIcon /> Einstellungen
            </div>
          </div>
        </div>
      ) : (
        <div className="sellerprofile_topnav">
          <div
            className="sellerprofile_topnav_left_title"
            onClick={() =>
              isEmpty(authToken) ? navigate("/menu") : navigate(-1)
            }>
            <ArrowBackDesktop />
            Dein Werbeaccount
          </div>
          <div className="seller_topnav_right">
            <div
              className="seller_topnav_right_earnings button"
              onClick={() => navigate("/menu")}>
              Menu
            </div>
          </div>
        </div>
      )}

      <div className="sellerprofile_body">
        <div className="sellerprofile_body_headline"></div>
        <div className="sellerprofile_body_inputbox">
          <div className="sellerprofile_body_inputbox_title">
            Dein Instagram Account
          </div>
          <div className="sellerprofile_body_inputbox_text">
            Gib den Accountnamen des Instagram Accounts ein, auf dem du Werbung
            platzieren möchtest.
          </div>
          <input
            className="sellerprofile_body_inputbox_input"
            placeholder="Accountname deines Instagram Profils "
            value={instaProfile}
            onChange={(e) => setInstaProfile(e.target.value)}
          />
          {/*
          
             <div className="sellerprofile_body_inputbox_text">
            Gib ein wieviele Follower der Account hat
          </div>
          <input
            className="sellerprofile_body_inputbox_input"
            placeholder="Followerzahl deines Instagram Profils"
            value={followerInstagram}
            onChange={(e) => setFollowerInstagram(e.target.value)}
          />
          
          */}
        </div>

        <div className="sellerprofile_body_inputbox">
          <div className="sellerprofile_body_inputbox_title">
            {" "}
            Dein Verdienst{" "}
          </div>
          <div className="sellerprofile_body_inputbox_text">
            Wähle aus, wieviel du pro Story, die du erstellst und teilst,
            verdienen möchtest. {"(Jederzeit später änderbar)"}
          </div>
          <div className="sellerprofile_body_inputbox_pricebar">
            <div
              className={
                storyPostPrice == "500"
                  ? "sellerprofile_body_inputbox_pricebar_boxActive"
                  : "sellerprofile_body_inputbox_pricebar_box"
              }
              onClick={() => setStoryPostPrice("500")}>
              € <br /> 5€
            </div>
            <div
              className={
                storyPostPrice == "2000"
                  ? "sellerprofile_body_inputbox_pricebar_boxActive"
                  : "sellerprofile_body_inputbox_pricebar_box"
              }
              onClick={() => setStoryPostPrice("2000")}>
              €€ <br /> 20€
            </div>
            <div
              className={
                storyPostPrice == "5000"
                  ? "sellerprofile_body_inputbox_pricebar_boxActive"
                  : "sellerprofile_body_inputbox_pricebar_box"
              }
              onClick={() => setStoryPostPrice("5000")}>
              €€€ <br /> 50€
            </div>
          </div>
        </div>

        {isEmpty(storyPostPrice) || isEmpty(instaProfile) ? (
          <div className="sellerprofile_body_savebtnDisabled button">
            Ausfüllen
          </div>
        ) : (
          <div
            className="sellerprofile_body_savebtn button"
            onClick={() => clickSaveButton()}>
            Speichern
          </div>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const SettingsIcon = styled(MdSettings)`
  font-size: 23px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const EditIcon = styled(MdEdit)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
